
/**
 * 按钮防抖指令，可自行扩展至input
 * <button v-debounce="debounce">提交</button>
 */
export default {
    mounted(el, binding) {
        if (typeof binding.value !== "function") {
            throw "callback must be a function";
        }

        let timer = null;
        el.handleClick = ()=>{
            if (timer) clearInterval(timer);
            timer = setTimeout(() => {
                binding.value();
            }, 500);
        };

        el.addEventListener("click", el.handleClick);
    },
    beforeUnmount(el) {
        el.removeEventListener("click", el.handleClick);
    }
};